<template>
    <div>
        <h2 class="tw-text-white tw-mb-10">{{ question.title }}</h2>

        <div class="tw-flex tw-space-x-4 tw-mb-10">
            <label
                class="tw-mb-0 tw-transition tw-flex tw-items-center tw-gap-3 tw-bg-white/10 tw-rounded tw-text-white tw-text-lg tw-px-6 tw-py-5"
                :class="{'tw-cursor-pointer hover:tw-bg-white/20': !answerResult.show}"
                @click="checkAnswer('yes')"
                for="yes"
            >
                <input v-model="clickedYes" type="radio" name="question" id="yes" class="tw-accent-primary-300">
                {{ buttonTextTrue }}
            </label>
            <label
                class="tw-mb-0 tw-transition tw-flex tw-items-center tw-gap-3 tw-bg-white/10 tw-rounded tw-text-white tw-text-lg tw-px-6 tw-py-5"
                :class="{'tw-cursor-pointer hover:tw-bg-white/20': !answerResult.show}"
                @click="checkAnswer('no')"
                for="no"
            >
                <input v-model="clickedNo" type="radio" name="question" id="no" class="tw-accent-primary-300">
                {{ buttonTextFalse }}
            </label>
        </div>
        <div v-if="answerResult.show" class="tw-bg-white tw-p-6 tw-space-y-2 tw-rounded-3xl tw-mb-10">
            <div class="tw-bg-primary-600 tw-text-lg tw-p-4 tw-rounded-3xl tw-flex tw-items-center tw-gap-2 tw-w-max tw-text-white">
                <i
                    class="fa tw-text-primary-300"
                    :class="[answerResult.correct ? 'fa-check' : 'fa-times']"
                />
                {{ answerResult.correct ? 'Helemaal juist!' : 'Niet goed' }}
            </div>
            <div
                class="tw-prose tw-text-lg tw-max-w-none"
                v-html="question[answerResult.correct ? 'explanation_yes' : 'explanation_no']"
            />
        </div>
        <button
            v-if="showNextButton && answerResult.show"
            class="tw-button"
            @click="nextQuestion"
        >
            {{ isLastQuestion ? 'Ga naar resultaat' : 'Volgende vraag' }}
        </button>
    </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    buttonTextTrue: {
      type: String,
      default: 'Waar',
    },
    buttonTextFalse: {
      type: String,
      default: 'Niet waar',
    },
    showNextButton: {
      type: Boolean,
      default: true,
    },
    isLastQuestion: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    clickedYes: false,
    clickedNo: false,
    answerResult: {
      show: false,
      correct: null,
    },
  }),
  methods: {
    checkAnswer(answer) {
      if (this.answerResult.show) {
        return;
      }

      const isCorrect = answer === this.question.correct_answer;

      this.answerResult = {
        show: true,
        correct: isCorrect,
      };

      if (isCorrect) {
        this.correctCount++;
      }
    },
    nextQuestion() {
      const isCorrect = JSON.parse(JSON.stringify(this.answerResult.correct));
      this.answerResult = {
        show: false,
        correct: null,
      };

      this.clickedYes = false;
      this.clickedNo = false;

      this.$emit('event:next', isCorrect);
    }
  },
};
</script>
